/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface GetLoginInfo$Params {
  Cookie: string;
}

export function getLoginInfo(
  http: HttpClient,
  rootUrl: string,
  params: GetLoginInfo$Params,
  context?: HttpContext,
): Observable<
  StrictHttpResponse<{
    [key: string]: string;
  }>
> {
  const rb = new RequestBuilder(rootUrl, getLoginInfo.PATH, 'get');
  if (params) {
    rb.header('Cookie', params.Cookie, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
        [key: string]: string;
      }>;
    }),
  );
}

getLoginInfo.PATH = '/loginservice/v1/';
